import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=27ea62c4&scoped=true"
import script from "./cooperation.vue?vue&type=script&lang=js"
export * from "./cooperation.vue?vue&type=script&lang=js"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=27ea62c4&prod&lang=css"
import style1 from "./cooperation.vue?vue&type=style&index=1&id=27ea62c4&prod&lang=less&scoped=true"
import style2 from "./cooperation.vue?vue&type=style&index=2&id=27ea62c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ea62c4",
  null
  
)

export default component.exports